import { render, staticRenderFns } from "./rates.vue?vue&type=template&id=84014ed8&scoped=true&"
import script from "./rates.vue?vue&type=script&lang=js&"
export * from "./rates.vue?vue&type=script&lang=js&"
import style0 from "./rates.vue?vue&type=style&index=0&id=84014ed8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84014ed8",
  null
  
)

export default component.exports